export default "__VITE_ASSET__B5xi4AuZ__"